import React from "react";
import MainRoutes from "./router/MainRoutes";

import Layout from "./components/Layout";
import { Switch, BrowserRouter, Route, Redirect, useLocation } from "react-router-dom";
import "@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js";
import { ViewportProvider } from "./context/ViewportContext";
import "./App.css";
import "./responsive.css";
import "./mobile-app.css";
// redux
import { Provider, useSelector } from "react-redux";
import store from "./redux/store";

const App: React.FC = () => {
  return (
    <ViewportProvider>
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/">
              <Redirect to="/Home" />
            </Route>
            <Main />
          </Switch>
        </BrowserRouter>
      </Provider>
    </ViewportProvider>
  );
};

const Main: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { user } = useSelector((reduxState: any) => reduxState.auth);
  const vendorId = user?.vendorId;

  const urlP = window.location.pathname;

  const isAdmin = window.location.pathname?.split("/")[1] === "admin" ? true : false;

  return (
    <>
      <Layout hideHeader={isHome} hideFooter={isHome}>
        <MainRoutes />
      </Layout>
    </>
  );
};

export default App;
